/* eslint-disable no-console */
/* eslint-env browser */
/* globals $ */

// eslint-disable-next-line no-unused-vars
function init(options) {
  let {
    unlimited,
    numberAttempts,
    contentId,
    resourceId,
    rawText,
    canBeGraded,
  } = options;
  let attempts = 0;
  let newText = '';
  let numSelects = 0;
  let inCollection = false;
  const has = Object.prototype.hasOwnProperty;

  try {
    inCollection = typeof (window.parent && window.parent.clearAssessment) !== 'undefined';
    window.attempts = attempts;
  } catch (e) {
    // nothing
  }

  rawText.split(/\{\{+(.*?)\}\}/g).forEach((item) => {
    if (rawText.indexOf(`{{${item}}}`) === -1) {
      newText += item;
    } else {
      newText += `<span id="multiBlank${numSelects}Feedback"></span><select class="multiBlank" id="multiBlank${numSelects}" ><option value="" selected>[Select]</option>`;
      try {
        Function('return [' + item + ']')().forEach((match) => { newText += `<option>${match}</option>`; });
      } catch (err) {
        console.log(`Couldn't interpret select, error: ${err}`);
      }
      newText += '</select>';
      numSelects += 1;
    }
  });

  /* This is probably no longer used.
  function decrementAttempts(attemptsLen) {
    attempts += attemptsLen;
  }
  */
  console.log('fitb unlimited:', unlimited);
  function mark(result) {
    attempts += 1;
    if (inCollection) {
      window.attempts = attempts;
    }
    if (!unlimited) {
      $('#fitb_attempts').removeClass('d-none');
      if (Math.max(0, numberAttempts - attempts) > 0) {
        $('.fitb_attempts').html(`${Math.max(0, numberAttempts - attempts)} attempt(s) remaining, please remain in the current browser session to utilise these.`);
      } else {
        $('.fitb_attempts').html('0 attempts remaining');
      }
    }

    if (has.call(result, 'feedback') && has.call(result.feedback, 'marks')) {
      result.feedback.marks.forEach((isCorrect, index) => {
        const $currentFeedback = $(`#multiBlank${index}Feedback`);
        const $currentSelect = $(`#multiBlank${index}  option:selected`);

        if (isCorrect) {
          $currentFeedback.removeClass();
          $currentFeedback.addClass('fa fa-check correctFeedback');
          $currentFeedback.attr('title', 'Correct!');
          // $(`#multiBlank${index}`).prop('disabled', true);  // Might be too faded?
          $(`#multiBlank${index}`).addClass('correctBorder');
        } else {
          $(`#multiBlank${index}`).addClass('incorrectBorder');
          $currentSelect.prop('disabled', true);
          $currentFeedback.removeClass();
          $currentFeedback.addClass('fa fa-times incorrectFeedback');
          $currentFeedback.attr('title', 'This answer is incorrect.');
        }
      });
    }

    $('#fitb_blueCard').removeClass('d-none');
    
    if (result.correct.toString() === 'true' && !inCollection && unlimited) {
      $('#fitb_submit').attr('disabled', true).addClass('text-dark');
      $('#fitb_reload').removeClass('d-none');
    }
    else if (!unlimited && Math.max(0, numberAttempts - attempts) === 0) {
      $('#fitb_submit').attr('disabled', true).addClass('text-dark');
    }

    if (result.feedback && result.feedback.overall) $('#fitb_feedback').html(`<h4 class="text-white"><strong>General Feedback:</strong> ${result.feedback.overall.replace(/(<p[^>]+?>|<p>)/img, '<p class="text-white">')}</h4>`);


    if ($('#footer').length > 0) {
      const footerHeight = Number($('#footer').outerHeight(true));
      if ($('body').height() + footerHeight > $(window).height()) {
        $('#footer').css('position', 'inherit');
      }
    }

    $('html, body').animate({
      scrollTop: $('#fitb_blueCard').offset().top,
    }, 1000);

    if (inCollection && result.feedback.answers) {
      result.feedback.answers.forEach((answer, idx) => {
        if (answer && answer !== '') $(`#multiBlank${idx}`).val(answer);
      });
    }
  }
 
  window.MultiFitb_mark = mark;
 

  $(document).ready(() => {
    $('#fitb_questionText').html(newText);
    if (!unlimited) {
      $('#fitb_attempts').removeClass('d-none');
      $('.fitb_attempts').html(`${Math.max(0, numberAttempts - attempts)} attempt(s) remaining`);
    }

    // when focused or changed, announce entire text content with blanks to give context
    $('#fitb_questionText .multiBlank').on("focus change", function(){
      $(this).parent().children('.multiBlank').each(function(){
        let el = $(this).parent().contents();
        let elText = el.filter(function(){ return this.nodeType === Node.TEXT_NODE || this.nodeName == "SELECT";}); 
        let ariaLabel = "";
        if (elText.length > 1){
          let sentence = "";
          for (var key in elText) {
            if (elText.hasOwnProperty(key)) {
              if (elText[key].nodeName == "#text" && elText[key].textContent){
               sentence += elText[key].textContent;
              }
              else if (elText[key].nodeName == "SELECT"){
        let value = elText[key].value === "" ? "[SELECT]" :elText[key].value;
       sentence += value;
              }
            }
          }
          ariaLabel = sentence;
        }
        else{
          ariaLabel =elText.value;
        }
        $(this).attr('aria-label', ariaLabel);
      });
    });

    // remove aria label for selects when not focused to get rid of redundancy/verbosity
    $('#fitb_questionText .multiBlank').on("blur", function(){
      $(this).parent().children('.multiBlank').each(function(){
          $(this).removeAttr('aria-label');
        });
    });

    $('.multiBlank').change(function multiBlank() {
      const $myself = $(this);
      const myName = $myself.attr('id');
      $myself.removeClass('correctBorder incorrectBorder');
      $(`#${myName}Feedback`).removeClass();
      $(`#${myName}Feedback`).attr('title', null);
    });

    $('#fitb_reload').click(() => {
      // eslint-disable-next-line no-restricted-globals
      location.reload();
    });
    
    

    $('#fitb_quizForm').submit((event) => {
      event.preventDefault();
      mfitb_submitQuiz();
    });


    function mfitb_submitQuiz() {
      const answers = [];
      for (let i = 0; i < numSelects; i += 1) {
        answers.push($(`#multiBlank${i}`).val());
      }

      const formData = {
        response: {
          multiFitbResponse: { answers },
        },
        resourceId,
        contentId,
        contentType: 'MultiFitb',
        inCollection
      };

      $.ajax({
        type: 'POST',
        url: '/access/content/evaluate',
        data: formData,
        dataType: 'json',
        encode: true,
      })
        .done((data) => {
          const result = (data && data.result && data.result.result)
            ? data.result.result : data.result;
          mark(result);
          // for resource collection assessment
          if (inCollection) {
            window.parent.clearAssessment(result.correct ? 1 : 0, formData, result);
          }
        })
        .fail(function(err) {
          if (err && err.responseJSON && err.responseJSON.message) {
            var errMsg = err.responseJSON.message;

            if (errMsg === 'content has expired') {
              $("#fitb_blueCard").removeClass("d-none");

              $("#fitb_blueCard").find('h4')
                .html("Your Session has timed out")
                .append(
                `<p class="text-white">
                  Your activity could not be evaluated because your session has timed out. This is likely because you are viewing multiple pieces of content at the same time. Please reload this activity and try again.
                </p>`
              );

              $("#fitb_submit")
                .css("display", "none");


              $("html, body").animate({
                scrollTop: $("#fitb_blueCard").offset().top
              }, 1000);
            }
          }
        });
    }
  });
}
